import { OverlayTrigger, ProgressBar, Toast, Tooltip } from "react-bootstrap";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import TitleLogoComponent from "../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import {
  SessionKeys,
  getTimeDiff,
  truncatedDescription,
} from "../../../utils/AppUtils";
import Dropdown from "react-bootstrap/Dropdown";
import "./ProductCardComponent.scss";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import { OfferTagBtnIcon, RightArrowIcon } from "../../../utils/SvgComps";
import CONFIG from "../../../utils/config";
import API_LIST from "../../../utils/apiList";
import { postLikeDisLikeProduct } from "../../../redux/discuss/actions";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useLogin from "../../../custom-hooks/useLogin";
import _ from "lodash";
import ProductBundleComp from "./ProductBundleComp";
import {
  addToWishList,
  addToWishListClear,
  getWishList,
  removeFromWishList,
} from "../../../redux/product/actions";
import Loader from "../../Loader/Loader";
import { getShowLoader } from "../../../redux/home/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Rating from "@mui/material/Rating";
import OverDueStatus from "./OverDueStatus";
const ProductCardComponent = (props) => {
  const {
    id,
    productType,
    productOrigin,
    dbId,
    is_like,
    is_bookmark,
    title,
    logoAltText,
    logoURL,
    bannerURL,
    tagsArray,
    descAction,
    description,
    btnTitle,
    btnAction,
    bannerAction,
    footerLineComp,
    showHeader,
    showBody,
    showFooter,
    leftBtnIcon,
    rightBtnIcon,
    cardClassName,
    isLoading,
    progress,
    ratings,
    duration,
    showProgress,
    showPlayButton,
    showProviderIcon,
    lastKey,
    refInfo,
    showLikeMenu,
    showContentMenu,
    updatedAt,
    isCol12,
    priceInfo,
    isBundle,
    bundles,
    show4,
    ecom_id,
    is_wishlist,
    showSubmitAndReview,
    showSubmittedBy,
    submittedBy,
    submittedOn,
    showReviewedBy,
    reviewedBy,
    feedbackStatus,
    reviewedOn,
    fromWishList,
    isCart,
    is_coaching,
    show_subscription,
    isLock,
    tooltip,
    is_checklist_approved,
    checklist_approved_by,
    is_checklist_present,
    is_learn_more,
    setShowCL,
    setCheckListLp,
    clInfo,
    showRating,
    skills,
    skillsAsString,
    showIndustry,
    industry,
    showExperience,
    experience,
    status,
  } = props;
  const userDetails = useSelector((state) => state.user.userBroker);
  console.log("rating", ratings);
  const { t } = useTranslation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useLogin();
  const [show, setShow] = useState(false);
  const [isLikeClicked, setIsLikeClicked] = useState(false);
  const [isBookMarkClicked, setIsBookMarkClicked] = useState(false);
  const [isSavedToWishlist, setIsSavedToWishlist] = useState(false);
  useEffect(() => {
    setIsLikeClicked(is_like);
  }, [is_like]);

  useEffect(() => {
    setIsSavedToWishlist(is_wishlist);
  }, [is_wishlist]);

  useEffect(() => {
    setIsBookMarkClicked(is_bookmark);
  }, [is_bookmark]);

  const postLikeDisLike = () => {
    setIsLikeClicked(!isLikeClicked);
    setTimeout(() => {
      if (document.getElementById("idForTour") !== null) {
        document.getElementById("idForTour").click();
      }
    }, 800);
    dispatch(
      postLikeDisLikeProduct({
        URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LIKE_DISLIKE_PRODUCT}`,
        method: "post",
        isJSON: true,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_id: dbId ? dbId : "",
          entity_type: productType,
          origin: productOrigin,
          like: !is_like,
        },
      })
    );
  };

  const postBookmark = () => {
    setIsBookMarkClicked(!isBookMarkClicked);
  };

  const saveToLearnList = () => {
    setIsSavedToWishlist(!isSavedToWishlist);
    dispatch(getShowLoader("true"));
    dispatch(
      addToWishList({
        module: "addToWishList",
        postData: {
          pid:
            productType === "learningpath"
              ? _.toNumber(ecom_id)
              : _.toNumber(id),
          uemail: localStorage.getItem(SessionKeys.EMAIL_SESSION),
        },
      })
    );
  };

  const removeFromWishListResponse = useSelector(
    (state) => state.product.removeWishListData
  );
  const [removeWishList, setremoveWishList] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(removeFromWishListResponse) && removeWishList) {
      if (removeFromWishListResponse?.status === "success") {
        dispatch(getShowLoader("true"));
        dispatch(
          getWishList({
            module: "getWishList",
            email: localStorage.getItem(SessionKeys.EMAIL_SESSION),
          })
        );
      }
    }
  }, [removeFromWishListResponse]);

  const RemoveFromLearnList = () => {
    setremoveWishList(true);
    dispatch(getShowLoader("true"));
    dispatch(
      removeFromWishList({
        module: "removeFromWishList",
        postData: {
          pid: _.toNumber(id),
        },
      })
    );
  };

  const renderMainComp = () => {
    return (
      <>
        <div className="inner-coursecard" title={tooltip}>
        { (status === "over-due" || status === "overdue") && 
          <OverDueStatus />
        }
          {showHeader ? (
            <>
              {isLoading ? (
                <div className="shimmer-img">
                  <ShimmerScreen
                    case="rect"
                    width="100%"
                    height="12rem"
                    borderRadius="10px"
                  />
                </div>
              ) : isBundle ? (
                <div className="card-img-section  position-relative product-img-sec">
                  <ProductBundleComp
                    bundles={bundles}
                    priceInfo={priceInfo}
                    bannerAction={bannerAction}
                    bannerURL={bannerURL}
                    isCart={isCart}
                  />
                </div>
              ) : !bannerURL ? (
                <div className="card-img-section position-relative product-img-sec">
                  {!_.isEmpty(priceInfo) ? (
                    priceInfo.isOffer ? (
                      <div className="spacial-tag">{<OfferTagBtnIcon />}</div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <div
                    className={`d-flex justify-content-center align-items-center bk-grey cursor-pointer empty-img`}
                    onClick={
                      isCart ? () => navigate(bannerAction) : bannerAction
                    }
                  >
                    {(status === "over-due" || status === "overdue")? <div className="new-tag">
                      <span className="new-tag-ribbon new-tag-ribbon-overdue">{t("Overdue")}</span>
                    </div>:(progress === "" ||
                      progress === undefined ||
                      progress === null ||
                      progress === 0) &&
                      updatedAt !== undefined &&
                      getTimeDiff(updatedAt) && (
                        <div className="new-tag">
                          <span className="new-tag-ribbon">{t("New")}</span>
                        </div>
                      )}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: title,
                      }}
                    ></p>
                    <div className="d-flex justify-content-between align-items-center position-absolute info-btm-pcard">
                      {is_checklist_approved ? (
                        <div class="approvedbysec">
                          <div class="fgf">
                            <p title={checklist_approved_by}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(41,45,50,1)"
                              >
                                <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path>
                              </svg>{" "}
                              Approved By: {checklist_approved_by}
                            </p>
                          </div>
                        </div>
                      ) : is_checklist_present ? (
                        <div class="approvedbysec">
                          <div class="fgf">
                            <p title={userDetails?.payload?.payload?.manager}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(41,45,50,1)"
                              >
                                <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path>
                              </svg>{" "}
                              Approver: {userDetails?.payload?.payload?.manager}
                            </p>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {is_checklist_present ? (
                        <span
                          className={`checklistingo cursor-pointer`}
                          onClick={() => {
                            setShowCL(true);
                            setCheckListLp(clInfo);
                          }}
                          title="Checklist"
                        >
                          <img
                            src="/images/checklist.png"
                            width={32}
                            height={32}
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="card-img-section  position-relative cursor-pointer product-img-sec">
                    {(status === "over-due" || status === "overdue")? <div className="new-tag">
                      <span className="new-tag-ribbon new-tag-ribbon-overdue">{t("Overdue")}</span>
                    </div>:(progress === "" ||
                      progress === undefined ||
                      progress === null ||
                      progress === 0) &&
                      updatedAt !== undefined &&
                      getTimeDiff(updatedAt) && (
                        <div className="new-tag">
                          <span className="new-tag-ribbon">{t("New")}</span>
                        </div>
                      )}
                    {!_.isEmpty(priceInfo) ? (
                      priceInfo?.isOffer ? (
                        <div className="spacial-tag">{<OfferTagBtnIcon />}</div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {
                      <img
                        className="cardthum"
                        src={bannerURL}
                        alt={title}
                        onClick={
                          isCart ? () => navigate(bannerAction) : bannerAction
                        }
                        loading="lazy"
                      />
                    }

                    {productType === "coach" ? (
                      <div className="overlay-box-ino d-flex justify-content-between">
                        {showIndustry ? (
                          <div className="infobox">{industry}</div>
                        ) : (
                          ""
                        )}

                        {showExperience ? (
                          <div className="infobox">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_935_21063)">
                                <path
                                  d="M2.04761 10.502V14.6625H11.8704V10.502H2.04761Z"
                                  fill="#4D5E80"
                                />
                                <path
                                  d="M6.95898 10.502H11.8704V14.6625H6.95898V10.502Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M6.5498 10.979H7.36838V12.2069H6.5498V10.979Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M6.95898 10.979H7.36827V12.2069H6.95898V10.979Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M9.00545 7.70463H8.18688V6.74502C7.91274 6.63658 7.42902 6.47677 6.95902 6.47677C6.48914 6.47677 6.0055 6.6365 5.73117 6.74505V7.70463H4.9126V6.22381L5.13885 6.11068C5.1758 6.09221 6.05423 5.6582 6.95902 5.6582C7.86381 5.6582 8.74225 6.09221 8.77919 6.11068L9.00545 6.22381V7.70463Z"
                                  fill="#4D5E80"
                                />
                                <path
                                  d="M8.18684 6.74502V7.70463H9.00541V6.22381L8.77916 6.11068C8.74221 6.09221 7.86378 5.6582 6.95898 5.6582V6.47677C7.42898 6.47677 7.9127 6.63658 8.18684 6.74502Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M11.8704 7.29541V10.502L6.95903 11.3951L2.04761 10.502V7.29541H11.8704Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M11.8704 7.29541H6.95898V11.3951L11.8704 10.502V7.29541Z"
                                  fill="#2E2E4D"
                                />
                                <path
                                  d="M3.57527 6.55573L2.20965 6.12819L0.844027 6.55573L0.828638 5.12484L0 3.95816L1.35612 3.50135L2.20965 2.35278L3.06317 3.50135L4.41929 3.95816L3.59068 5.12484L3.57527 6.55573Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M5.59351 4.91852L5.57812 3.48764L4.74951 2.32096L6.10564 1.86414L6.95916 0.715576L7.81265 1.86414L9.16878 2.32096L8.34017 3.48764L8.32481 4.91855L6.95916 4.49101L5.59351 4.91852Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M13.1561 6.55576L11.7904 6.12822L10.4248 6.55576L10.4094 5.12484L9.58081 3.95816L10.9369 3.50135L11.7904 2.35278L12.6439 3.50135L14 3.95816L13.1714 5.12484L13.1561 6.55576Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M8.32463 4.91852L8.33999 3.48761L9.1686 2.32096L7.81248 1.86414L6.95898 0.715576V4.49098L8.32463 4.91852Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M13.1559 6.55573L13.1713 5.12484L13.9999 3.95816L12.6438 3.50135L11.7903 2.35278V6.12819L13.1559 6.55573Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M3.57536 6.55573L3.59075 5.12484L4.41936 3.95816L3.06324 3.50135L2.20972 2.35278V6.12819L3.57536 6.55573Z"
                                  fill="#FFBE40"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_935_21063">
                                  <rect
                                    width="14"
                                    height="14"
                                    fill="white"
                                    transform="translate(0 0.688965)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            Exp {experience}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    {showPlayButton ? (
                      <>
                        {/* <span className="muteicon-btn"></span> */}
                        <button
                          className="playbtn"
                          onClick={
                            isCart ? () => navigate(bannerAction) : bannerAction
                          }
                        ></button>
                        <span className="duration-bar">{duration}</span>
                      </>
                    ) : (
                      ""
                    )}
                    {is_coaching && show_subscription && (
                      <div className="subscriptiontag">{t("Subscription")}</div>
                    )}
                    <div className="d-flex justify-content-between align-items-center position-absolute info-btm-pcard">
                      {is_checklist_approved ? (
                        <div class="approvedbysec">
                          <div class="fgf">
                            <p title={checklist_approved_by}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(41,45,50,1)"
                              >
                                <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path>
                              </svg>{" "}
                              Approved By: {checklist_approved_by}
                            </p>
                          </div>
                        </div>
                      ) : is_checklist_present ? (
                        <div class="approvedbysec">
                          <div class="fgf">
                            <p title={userDetails?.payload?.payload?.manager}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(41,45,50,1)"
                              >
                                <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path>
                              </svg>{" "}
                              Approver: {userDetails?.payload?.payload?.manager}
                            </p>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {is_checklist_present ? (
                        <span
                          className={`checklistingo cursor-pointer`}
                          onClick={() => {
                            setShowCL(true);
                            setCheckListLp(clInfo);
                          }}
                          title="Checklist"
                        >
                          <img
                            src="/images/checklist.png"
                            width={32}
                            height={32}
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="cardtop-row module-box-sec">
                {showProviderIcon ? (
                  <TitleLogoComponent
                    logoURL={logoURL}
                    altText={logoAltText}
                    isLoading={isLoading}
                  />
                ) : null}
                <div className="card-main">
                  {isLoading ? (
                    <div className="card-logorow">
                      <div>
                        <ShimmerScreen case="rect" width="100%" height="1rem" />
                      </div>
                      <div className="mt-1">
                        <ShimmerScreen case="rect" width="70%" height="1rem" />
                      </div>
                    </div>
                  ) : (
                    <OverlayTrigger
                      key="top"
                      placement="top-start"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          <div
                            style={{
                              color: "white",
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="card-logorow"
                              onClick={
                                isCart
                                  ? () => navigate(bannerAction)
                                  : bannerAction
                              }
                              dangerouslySetInnerHTML={{
                                __html: title,
                              }}
                            ></span>
                          </div>
                        </Tooltip>
                      }
                    >
                      <span
                        className="card-logorow"
                        onClick={
                          isCart ? () => navigate(bannerAction) : bannerAction
                        }
                        dangerouslySetInnerHTML={{
                          __html: title,
                        }}
                      ></span>
                    </OverlayTrigger>
                  )}
                  <TitleTagsComponent
                    tagsArray={tagsArray}
                    isLoading={isLoading}
                  />
                </div>

                {isLoading ? (
                  <ShimmerScreen case="rect" width="0.4rem" height="1.5rem" />
                ) : (
                  showLikeMenu &&
                  isLoggedIn && (
                    <Dropdown className="customdropdown-btn">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {true && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="5"
                            height="16"
                            viewBox="0 0 5 16"
                            fill="none"
                          >
                            <path
                              d="M2.57441 16C2.01066 16 1.52806 15.8042 1.1266 15.4125C0.725143 15.0208 0.524414 14.55 0.524414 14C0.524414 13.45 0.725143 12.9792 1.1266 12.5875C1.52806 12.1958 2.01066 12 2.57441 12C3.13816 12 3.62077 12.1958 4.02223 12.5875C4.42368 12.9792 4.62441 13.45 4.62441 14C4.62441 14.55 4.42368 15.0208 4.02223 15.4125C3.62077 15.8042 3.13816 16 2.57441 16ZM2.57441 10C2.01066 10 1.52806 9.80417 1.1266 9.4125C0.725143 9.02083 0.524414 8.55 0.524414 8C0.524414 7.45 0.725143 6.97917 1.1266 6.5875C1.52806 6.19583 2.01066 6 2.57441 6C3.13816 6 3.62077 6.19583 4.02223 6.5875C4.42368 6.97917 4.62441 7.45 4.62441 8C4.62441 8.55 4.42368 9.02083 4.02223 9.4125C3.62077 9.80417 3.13816 10 2.57441 10ZM2.57441 4C2.01066 4 1.52806 3.80417 1.1266 3.4125C0.725143 3.02083 0.524414 2.55 0.524414 2C0.524414 1.45 0.725143 0.979167 1.1266 0.5875C1.52806 0.195833 2.01066 0 2.57441 0C3.13816 0 3.62077 0.195833 4.02223 0.5875C4.42368 0.979167 4.62441 1.45 4.62441 2C4.62441 2.55 4.42368 3.02083 4.02223 3.4125C3.62077 3.80417 3.13816 4 2.57441 4Z"
                              fill="#292D32"
                            />
                          </svg>
                        )}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div
                          className={`list-drop like-btn ${
                            isLikeClicked ? "active" : ""
                          }`}
                          onClick={() => postLikeDisLike()}
                          disabled={
                            !isLoggedIn
                            // !showContentMenu?.showLike
                          }
                        >
                          {isLikeClicked ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  fill="#ff2600"
                                  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                                />
                              </svg>{" "}
                            </>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="black"
                            >
                              <path
                                d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                                fill="black"
                              />
                            </svg>
                          )}{" "}
                          {t("Like")}
                        </div>

                        {(productOrigin === "xsel" ||
                          productOrigin === "ecom") &&
                        productType !== "Certification" &&
                        productType !== "Event" &&
                        productType !== "partner" &&
                        !priceInfo?.isPurchased &&
                        !priceInfo?.isFree ? (
                          <div
                            className={`list-drop like-btn ${
                              isSavedToWishlist ? "active" : ""
                            }`}
                            onClick={() =>
                              isSavedToWishlist
                                ? ""
                                : fromWishList
                                ? RemoveFromLearnList()
                                : saveToLearnList()
                            }
                            disabled={
                              !isLoggedIn
                              // !showContentMenu?.showLearnList
                            }
                          >
                            {isSavedToWishlist ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                                  fill="#0fb41c"
                                ></path>
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                                  fill="black"
                                />
                              </svg>
                            )}{" "}
                            {fromWishList
                              ? t("Remove from Wishlist")
                              : isSavedToWishlist
                              ? t("Added to Wishlist")
                              : t("Save to Wishlist")}
                          </div>
                        ) : (
                          ""
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {showBody ? (
            isLoading ? (
              <>
                {[1, 2, 3].map((t, i) => {
                  return (
                    <div
                      className={`${i > 0 ? "mt-1" : ""}`}
                      key={`product-card-shimmer-${i + 1}`}
                    >
                      <ShimmerScreen case="react" width="100%" height="1rem" />
                    </div>
                  );
                })}
              </>
            ) : showRating ? (
              <>
                <div className="above-info">
                  <div className="coach-desx">
                 
                      {skillsAsString
                        ? skills
                        : skills?.map((skill, index) => {
                            if (
                              _.toNumber(skills.length - 1) ===
                              _.toNumber(index)
                            ) {
                              return skill;
                            } else {
                              return `${skill},${" "}`;
                            }
                          })}
               
                  </div>
                  {!skillsAsString && (
                    <div className="foddd w-100">
                      <div className="key-skills-coach">
                        <p className="mb-2">
                          <strong>{t("Ratings")}</strong>
                        </p>
                        <div className="d-flex align-items-center gap-3">
                          <div className="forn-ed">
                            <strong>{ratings}</strong>
                          </div>
                          <div className="rating-boxca">
                            <Rating
                              name="half-rating"
                              value={ratings}
                              precision={0.5}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div
                  className="xldiscription-box"
                  dangerouslySetInnerHTML={{
                    __html: truncatedDescription(description, 200),
                  }}
                ></div>
              </>
            )
          ) : (
            ""
          )}

          {showSubmitAndReview
            ? showSubmittedBy && (
                <div className="roleplay-head">
                  <span>
                    Submitted by {submittedBy} on {submittedOn}
                  </span>
                </div>
              )
            : " "}
          {showSubmitAndReview ? (
            showReviewedBy ? (
              feedbackStatus ? (
                <div className="roleplay-head">
                  <span style={{ color: "#27B710" }}>
                    Reviewed by {reviewedBy} on {reviewedOn}
                  </span>
                </div>
              ) : (
                <div className="roleplay-head">
                  <span style={{ color: "#D32A3F" }}>Under review</span>
                </div>
              )
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {isLoading && (
            <div className="cardbtn-row">
              <div className="progress-bar-box">
                {" "}
                <ShimmerScreen case="rect" width="10rem" height=".625rem" />
              </div>
              <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
                <div>
                  <ShimmerScreen case="rect" width="10rem" height="1rem" />
                </div>
                <div>
                  <ShimmerScreen
                    case="rect"
                    width="5rem"
                    height="2.4375rem"
                    borderRadius="10px"
                  />
                </div>
              </div>
            </div>
          )}
          {showFooter ? (
            <div className="cardbtn-row">
              {showProgress ? (
                <div className="progress-bar-box">
                  <ProgressBar
                    className="progeress-bar-new"
                    variant="success"
                    now={progress ? progress : 0}
                  />
                  {progress && progress > 0 ? (
                    <div className="progress-box"> {progress}%</div>
                  ) : (
                    ""
                  )}
                </div>
              ) : isLoading ? (
                ""
              ) : (
                <div className="sep"></div>
              )}

              <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
                {isLoading ? (
                  <>
                    <div>
                      <ShimmerScreen case="rect" width="10rem" height="1rem" />
                    </div>
                    <div>
                      <ShimmerScreen
                        case="rect"
                        width="5rem"
                        height="1.5rem"
                        borderRadius="10px"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="price-sec-xl">{footerLineComp}</div>
                    {/* <FormButtonComponent 
                                            btnName={btnTitle}
                                            leftIcon={leftBtnIcon}
                                            rightIcon={rightBtnIcon}
                                            altText=""
                                            btnAction={btnAction}
                                            isPrimary={false}
                                        /> */}
                    <button
                      type="button"
                      className={isLock ? "locked-btn-b2c" : "startcourse-btn"}
                      onClick={btnAction}
                    >
                      {isLock && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            opacity="0.12"
                            d="M4.5 15.8C4.5 14.1198 4.5 13.2798 4.82698 12.638C5.1146 12.0735 5.57354 11.6146 6.13803 11.327C6.77976 11 7.61984 11 9.3 11H15.7C17.3802 11 18.2202 11 18.862 11.327C19.4265 11.6146 19.8854 12.0735 20.173 12.638C20.5 13.2798 20.5 14.1198 20.5 15.8V16.2C20.5 17.8802 20.5 18.7202 20.173 19.362C19.8854 19.9265 19.4265 20.3854 18.862 20.673C18.2202 21 17.3802 21 15.7 21H9.3C7.61984 21 6.77976 21 6.13803 20.673C5.57354 20.3854 5.1146 19.9265 4.82698 19.362C4.5 18.7202 4.5 17.8802 4.5 16.2V15.8Z"
                            fill="black"
                          />
                          <path
                            id="lcked"
                            d="M17.5 11V8C17.5 5.23858 15.2614 3 12.5 3C9.73858 3 7.5 5.23858 7.5 8V11M9.3 21H15.7C17.3802 21 18.2202 21 18.862 20.673C19.4265 20.3854 19.8854 19.9265 20.173 19.362C20.5 18.7202 20.5 17.8802 20.5 16.2V15.8C20.5 14.1198 20.5 13.2798 20.173 12.638C19.8854 12.0735 19.4265 11.6146 18.862 11.327C18.2202 11 17.3802 11 15.7 11H9.3C7.61984 11 6.77976 11 6.13803 11.327C5.57354 11.6146 5.1146 12.0735 4.82698 12.638C4.5 13.2798 4.5 14.1198 4.5 15.8V16.2C4.5 17.8802 4.5 18.7202 4.82698 19.362C5.1146 19.9265 5.57354 20.3854 6.13803 20.673C6.77976 21 7.61984 21 9.3 21Z"
                            stroke="#415385"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                      {btnTitle}
                      {!isLock && <RightArrowIcon />}
                    </button>
                  </>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {show4 ? (
        renderMainComp()
      ) : lastKey ? (
        <div
          ref={refInfo}
          className={` mb-botm col-md-12 col-lg-6 ${
            isCol12 ? "col-xl-12" : "col-xl-4"
          } ${lastKey ? "last-key" : ""} ${cardClassName ? cardClassName : ""}`}
        >
          {renderMainComp()}
        </div>
      ) : (
        <div
          className={` mb-botm col-md-12 col-lg-6 ${
            isCol12 ? "col-xl-12" : "col-xl-4"
          } ${cardClassName ? cardClassName : ""}`}
        >
          {renderMainComp()}
        </div>
      )}
    </>
  );
};

export default ProductCardComponent;
